import { autorun, extendObservable, computed, action } from "mobx";
import en from 'react-intl/locale-data/en';
import es from 'react-intl/locale-data/es';
import defaultLocales from '../../../locales/default.json';
import alertLocales from '../../../locales/alerts.json';
import { addLocaleData, IntlProvider } from 'react-intl';
addLocaleData([...es, ...en]);
import moment from 'moment';
import { flattenMessagesWithoutLocalesPrefixes } from "./functions";
const flattenedAlertMessages = flattenMessagesWithoutLocalesPrefixes(alertLocales);


export default class Locale {

  /***************************************************************
  * @locale: String. Ex. "en"
  * @translations: Array of localization json files
  ****************************************************************/
  constructor(locale, translations) {
    this.translations = translations;
    this._intl = "";
    this.moment = moment;

    extendObservable(this, {
      locale: locale,
    })

    // Bind the updateIntl in order to update the 
    // intl object after every locale change
    this.updateIntl = this.updateIntl.bind(this);
    autorun(this.updateIntl);
    autorun(() => { this.moment.locale(this.locale) });
    //moment.locale(locale);
  }

  /*************************************************************
  * Localization messages depending on the current locale.
  * Useful to use with the IntlProvider component.
  **************************************************************/
  @computed get messages() {
    const defaultLocalesMessages = defaultLocales[this.locale] || {};
    const alertMessages = flattenedAlertMessages[this.locale] || {};
    let _messages = { ...defaultLocalesMessages, ...alertMessages };
    for (const translation of this.translations) {
      _messages = { ..._messages, ...translation[this.locale] }
    }
    return _messages;
  }


  /******************************************************************
  * Set the new current locale. It produces the computed messages 
  * value to change and thus trigger reactions in all bound obervers
  * @locale: String. Ex. "en"
  *******************************************************************/
  @action setLocale(locale) {
    this.locale = locale;
  }


  /********************************************************************
  * The intl object will be updated after every 
  * locale or messages change
  *********************************************************************/
  @action
  updateIntl() {
    const intlProvider = new IntlProvider({ locale: this.locale, messages: this.messages }, {});
    this._intl = intlProvider.getChildContext().intl;
  }


  /********************************************************************
  * Avoid setting the _intl object. Provide only a getter.  
  **********************************************************************/
  get intl() {
    return this._intl;
  }

}